import request from '@/utils/request'

const urlPrefix = '/services'

export function getService (id) {
  return request.get(`${urlPrefix}/${id}`)
}

export function updateService (id, data) {
  return request.put(`${urlPrefix}/${id}`, data)
}

export function deleteService (id) {
  return request.delete(`${urlPrefix}/${id}`)
}

export function generateServiceTopology (id) {
  return request.get(`${urlPrefix}/${id}/topology/generate`)
}

export function getServiceCount (params) {
  return request.get(`${urlPrefix}/count`, { params })
}

export function getServiceOSList (id, params) {
  return request.get(`${urlPrefix}/${id}/oses`, { params })
}

export function getServiceMiddlewareList (id, params) {
  return request.get(`${urlPrefix}/${id}/middlewares`, { params })
}

export function getServiceDatabaseList (id, params) {
  return request.get(`${urlPrefix}/${id}/databases`, { params })
}

export function getServiceApplicationList (id, params) {
  return request.get(`${urlPrefix}/${id}/applications`, { params })
}

export function getServiceSiteList (id, params) {
  return request.get(`${urlPrefix}/${id}/sites`, { params })
}

export function getServiceSSLCertificateList (id, params) {
  return request.get(`${urlPrefix}/${id}/ssl-certificates`, { params })
}

export function getServiceStatistic (id) {
  return request.get(`${urlPrefix}/${id}/statistic`)
}

export function getServiceTrend (id, params) {
  return request.get(`${urlPrefix}/${id}/trend`, { params })
}

export function downloadServiceApproval (id, approvalId) {
  return request.get(`${urlPrefix}/${id}/approvals/${approvalId}`, {
    responseType: 'blob'
  })
}

export function deleteServiceApproval (id, approvalId) {
  return request.delete(`${urlPrefix}/${id}/approvals/${approvalId}`)
}

export function getServiceApprovalList (id, params) {
  return request.get(`${urlPrefix}/${id}/approvals`, { params })
}

export function createServiceApproval (id, data) {
  return request.post(`${urlPrefix}/${id}/approvals`, data)
}

export function getServiceList (params) {
  return request.get(urlPrefix, { params })
}

export function getServiceTop (params, time) {
  return request.get(`${urlPrefix}/top`, { params, timeout: 60 * 1000 * 3 })
}

export function createService (data) {
  return request.post(urlPrefix, data)
}

export function getServiceAlertList (id, params) {
  return request.get(`${urlPrefix}/${id}/alerts`, { params })
}

export function getServiceAlertCount (id, params) {
  return request.get(`${urlPrefix}/${id}/alerts/count`, { params })
}

export function getServiceEventList (id, params) {
  return request.get(`${urlPrefix}/${id}/events`, { params })
}

export function getServiceHealth (id) {
  return request.get(`${urlPrefix}/${id}/health`)
}

export function getServiceSourceBusyness (id) {
  return request.get(`${urlPrefix}/${id}/busyness`)
}

export function getServiceDashboardCount () {
  return request.get(`${urlPrefix}/dashboard-count`)
}
